import { render, staticRenderFns } from "./QuoteItemRow.vue?vue&type=template&id=70996d0e&"
import script from "./QuoteItemRow.vue?vue&type=script&lang=js&"
export * from "./QuoteItemRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports